<template>
  <div v-if="visible" class="sound-hint" role="region" aria-label="Alertas sonoros">
    <span class="sound-hint__icon" aria-hidden="true"><i class="fa-solid fa-bell"></i></span>
    <div class="sound-hint__copy">
      <strong>Ativar o som</strong>
      <span>Toque na tela para ativar o som</span>
    </div>
    <i class="fa-solid fa-xmark sound-hint__dismiss" aria-hidden="true"></i>
  </div>
</template>

<script>
export default {
  name: 'SoundHint',
  computed: {
    visible() {
      return !this.$store.state.soundMuted && !this.$store.state.canPlay;
    }
  }
};
</script>

<style scoped>
.sound-hint {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 12px 14px 22px;
  border-radius: 24px;
  background: var(--bg-theme-secondary);
  color: var(--text-default);
  border: 1px solid var(--border-color, #dee2e6);
  box-shadow: 0 1px 3px rgba(22, 24, 22, 0.04);
}
.sound-hint__dismiss {
  flex-shrink: 0;
  margin: 0 4px;
  color: var(--text-muted);
  font-size: 0.9rem;
}
.sound-hint__icon {
  display: grid;
  place-items: center;
  flex: 0 0 48px;
  height: 48px;
  border-radius: 16px;
  background: rgba(199, 244, 123, 0.22);
  border: 1px solid rgba(199, 244, 123, 0.34);
  color: #a3c613;
  font-size: 1.12rem;
}
.sound-hint__copy { flex: 1; min-width: 0; line-height: 1.3; }
.sound-hint__copy strong { display: block; font-size: 1.05rem; line-height: 1.2rem; }
.sound-hint__copy span { display: block; margin-top: 4px; font-size: 0.88rem; line-height: 1rem; color: var(--text-muted); }
.dark-mode .sound-hint { background: var(--bg-elevated); }
.dark-mode .sound-hint__icon {
  background: rgba(199, 244, 123, 0.14);
  border-color: rgba(199, 244, 123, 0.2);
  color: var(--primary);
}
@media (max-width: 420px) {
  .sound-hint { gap: 12px; padding-left: 14px; }
}
</style>
